import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import { Container } from 'layouts';

const Article = styled.div`
  background: ${props => props.theme.colors.white.white};
  min-height: 40vh;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    min-height: fit-content;
  }
`;

const ImgDiv = styled.div`
  vertical-align: middle;
  height: fit-content;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
  align-content: center;
  img {
    width: 100%;
    overflow: hidden;
    display: block;
  }
`;

const ContentDiv = styled.div`
  height: fit-content;
  padding: 2rem 1rem;
  h4, h6 {
    margin: 10px 0 0 0 !important;
  }
  h4 {
    line-height: 1.3;
    margin-bottom: 20px;
    margin-top: 5px;
  }  
  .readtime {
    margin-top: 0;
    color: ${props => props.theme.colors.white.gray};
    font-size: .8rem;
  }
  @media (max-width: ${props => props.theme.breakpoints.xl}) {
    min-height: 30vh;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    min-height: 25vh;
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    min-height: 20vh;
  }
`;

const BlogListItem = ({ path, cover, excerpt, tagsPost, title, subtitle, readtime }) => (
  <Container>
    <Article>
      <ImgDiv className='img-div post-card-header'>
        <Link to={`/blog/${path}`} title={title}>
          {tagsPost && <img src={cover} alt='title' />}
          {!tagsPost && <Img fluid={cover} />}
        </Link>
      </ImgDiv>
      <ContentDiv>
        <a href={`/blog/${path}`}>
          <h4>{title}</h4>
          {subtitle && <h6 className='subtitle' >{subtitle}</h6>}
          {readtime && <em className='readtime'>{readtime} min</em>}
        </a>
        {tagsPost && excerpt && <p>{excerpt}</p>}
      </ContentDiv>
    </Article>
  </Container>
);

export default BlogListItem;

BlogListItem.propTypes = {
  cover: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  excerpt: PropTypes.string,
  path: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  readtime: PropTypes.number,
  tagsPost: PropTypes.bool
};
